<template>
  <div class="flip text-center">
    <div class="front">
      <img class="flip-image mb-5" :src="image" :alt="alt">
      <slot name="front"></slot>
    </div>
    <div class="back">
      <slot name="back">
        <h2>Angular</h2>
        <p>Good tools make application development quicker and easier to maintain than if you did everything by
          hand..</p>
      </slot>
    </div>
  </div>
</template>

<script>
import mA from '../Tags/A'
import mImg from '../Tags/Img'
import {CardProps} from "./CardProps";


export default {
  name: "Card316",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps
  },
}

</script>

<style scoped>

.flip {
  position: relative;
  box-sizing: border-box;
}

.flip-image {
  width: 150px;
  height: 150px;
  object-fit: cover;
}

.flip > .front, .flip > .back {
  display: block;
  transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transition-duration: 0.5s;
  transition-property: transform, opacity;
}

.flip > .front {
  transform: rotateY(0deg);
}

.flip > .back {
  position: absolute;
  opacity: 0;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  transform: rotateY(-180deg);
}

.flip:hover > .front {
  transform: rotateY(180deg);
}

.flip:hover > .back {
  opacity: 1;
  transform: rotateY(0deg);
}

.flip.flip-vertical > .back {
  transform: rotateX(-180deg);
}

.flip.flip-vertical:hover > .front {
  transform: rotateX(180deg);
}

.flip.flip-vertical:hover > .back {
  transform: rotateX(0deg);
}

.flip {
  position: relative;
  display: inline-block;
  margin-right: 2px;
  margin-bottom: 1em;
  width: 100%;
}

.flip > .front, .flip > .back {
  display: block;
  color: #000;
  width: inherit;
  background-size: cover !important;
  background-position: center !important;
  height: 300px;
  padding: 1em 2em;
  background: #e6e6e6;
  border-radius: 25px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}

.flip > .front p, .flip > .back p {
  font-size: 0.9125rem;
  line-height: 160%;
  color: #999;
}

.flip > .back {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

</style>